import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scroll-to-top" }

import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowUpToLine } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollTopButton',
  setup(__props) {

library.add(faArrowUpToLine);

const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "scroll-to-top-button",
      onClick: toTop
    }, [
      _createVNode(_component_FontAwesomeIcon, { icon: _unref(faArrowUpToLine) }, null, 8, ["icon"])
    ])
  ]))
}
}

})